var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsMapsPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M12 1c3.866 0 7 3.134 7 7 0 1.415-.822 3.765-2.275 6.933-.258.565-.535 1.148-.826 1.747-.662 1.362-1.37 2.742-2.08 4.07-.247.464-.478.89-.685 1.266-.124.227-.214.387-.262.474L12 24.043l-.872-1.553c-.048-.087-.138-.247-.262-.474-.207-.377-.438-.802-.686-1.267-.708-1.327-1.417-2.707-2.08-4.07-.29-.598-.567-1.181-.825-1.746C5.822 11.765 5 9.415 5 8c0-3.866 3.134-7 7-7zm0 2C9.239 3 7 5.239 7 8c0 1.014.77 3.213 2.093 6.1.252.55.522 1.12.806 1.705.65 1.338 1.348 2.696 2.046 4.003l.055.103.055-.103c.698-1.307 1.395-2.665 2.046-4.003.284-.585.554-1.155.806-1.706C16.231 11.213 17 9.014 17 8c0-2.761-2.239-5-5-5zm0 3c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z",
    transform: "translate(-165 -3811) translate(0 3692) translate(165 119)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.01,
    strokeWidth: 0.01,
    d: "M0 0h24v24H0V0z",
    transform: "translate(-165 -3811) translate(0 3692) translate(165 119)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMapsPin);
export default __webpack_public_path__ + "static/media/icons-maps-pin.30335b734144f6f9eb4f7a3375cbf43d.svg";
export { ForwardRef as ReactComponent };